import { useMutation } from "@tanstack/react-query";
import { useAPIClient } from "render/context/APIContext";
import { useReporting } from "render/hooks/useReporting";

export function usePlayOutroMutation() {
  const apiClient = useAPIClient();
  const { logError } = useReporting();

  return useMutation({
    mutationFn({ patientId, visitId }: { patientId: string; visitId: string }) {
      return apiClient.visit.sendCommandToRoomController({
        patientId,
        visitId,
        command: "play_outro",
      }).result;
    },
    onError: (error) => logError(`Failed to play outro: ${error}`),
  });
}
